import { EventBus } from '.'

interface AgentEventsPayload {
  UNSAVED_CHANGES_POPUP_RESPONSE: (response: boolean) => void
  SIDEBAR_FORM_UNSAVED_CHANGES_RESPONSE: (response: boolean) => void
}

// Use this event bus to communicate events related to agent builder
export const agentEventBus = new EventBus<AgentEventsPayload>(undefined)
